import React from 'react';

interface HorizontalRulerProps {
    showRuler: boolean;
    rulerRef: React.RefObject<HTMLDivElement | null>;
    leftMargin: number;
    rightMargin: number;
    isDraggingMargin: 'left' | 'right' | null;
    dragGuidePosition: number;
    onSetIsDraggingMargin: (margin: 'left' | 'right' | null) => void;
    onSetDragGuidePosition: (position: number) => void;
}

export const HorizontalRuler: React.FC<HorizontalRulerProps> = ({
    showRuler,
    rulerRef,
    leftMargin,
    rightMargin,
    isDraggingMargin,
    dragGuidePosition,
    onSetIsDraggingMargin,
    onSetDragGuidePosition,
}) => {
    if (!showRuler) return null;

    return (
        <>
            <div className="horizontal-ruler-toolbar">
                <div className="horizontal-ruler-wrapper">
                    <div className="horizontal-ruler" ref={rulerRef}>
                        {Array.from({ length: 102 }, (_, i) => (
                            <div key={i} className="horizontal-ruler-mark">
                                {(i + 1) % 10 === 0 && <span className="horizontal-ruler-number">{i + 1}</span>}
                            </div>
                        ))}
                        
                        {/* Left Margin Slider */}
                        <div 
                            className="margin-slider left-margin"
                            style={{ left: `${leftMargin}px` }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                onSetIsDraggingMargin('left');
                                onSetDragGuidePosition(leftMargin);
                            }}
                        >
                            <div className="margin-slider-triangle"></div>
                        </div>
                        
                        {/* Right Margin Slider */}
                        <div 
                            className="margin-slider right-margin"
                            style={{ left: `${rightMargin}px` }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                onSetIsDraggingMargin('right');
                                onSetDragGuidePosition(rightMargin);
                            }}
                        >
                            <div className="margin-slider-triangle"></div>
                        </div>
                    </div>
                </div>
                
                {/* Drag Guide Line - positioned relative to ruler */}
                {isDraggingMargin && rulerRef.current && (
                    <div 
                        className="margin-drag-guide"
                        style={{ 
                            left: `${rulerRef.current.getBoundingClientRect().left + dragGuidePosition}px`
                        }}
                    />
                )}
            </div>
        </>
    );
};
